"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.esignContractDownloadApi = esignContractDownloadApi;
exports.esignContractListApi = esignContractListApi;
exports.esignContractSignUrlApi = esignContractSignUrlApi;
exports.esignPendingCountApi = esignPendingCountApi;
exports.esignReportSignedApi = esignReportSignedApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** 电子签合同（腾讯电子签标准版）：商户查看平台发来的合同，去腾讯电子签签署，签完反馈 */

function esignContractListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/esign/contract/list',
    method: 'get',
    params: params
  });
}
function esignPendingCountApi() {
  return (0, _request.default)({
    url: '/admin/merchant/esign/contract/pending-count',
    method: 'get'
  });
}

/** 签署入口：平台登记的签署链接（可能为空）与签署手机号 */
function esignContractSignUrlApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/esign/contract/sign-url/".concat(id),
    method: 'post'
  });
}

/** 在腾讯电子签签完后反馈，等待平台确认 */
function esignReportSignedApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/esign/contract/report-signed/".concat(id),
    method: 'post'
  });
}

/** 已完成合同 PDF */
function esignContractDownloadApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/esign/contract/download/".concat(id),
    method: 'get'
  });
}